<template>
  <div class="attendanceDetails">
    <b-card v-loading="loading">
      <div class="title">入座率詳情</div>
      <div class="mt-1 mb-1">
        <b-button size="sm" variant="outline-secondary" @click="$router.go(-1)"
          >返回上一頁</b-button
        >
      </div>
      <p>
        <b>{{ queryVal.titleName }}</b>
      </p>
      <b-table striped hover :items="items" :fields="fields">
        <template #thead-top="data">
          <b-tr>
            <b-th
                :colspan="queryVal.type === 'film'
                ? 7 : queryVal.type === 'theatre'
                ? 3 : 1"
            ></b-th>
<!--            <b-th v-if="queryVal.type !== 'film'"> total FILM :{{ totalVal("num_of_film", null) }}</b-th>-->
            <b-th v-if="queryVal.type !== 'film'"> total SHOW :{{ totalVal("num_of_show", null) }} </b-th>
            <b-th> total SEATS :{{ totalVal("seats", null) }}</b-th>
            <b-th> total ADM :{{ totalVal("ta", null) }}</b-th>
            <b-th> total B.O. :{{ totalVal("tg", null) }} </b-th>
            <b-th colspan="1"></b-th>
          </b-tr>
        </template>
        <template #cell(show)="data">
          <div class="text-nowrap">
            {{ parseFloat(Number(data.value)).toLocaleString() }}
          </div>
        </template>
        <template #cell(ta)="data">
          <div class="text-nowrap">
            {{ parseFloat(Number(data.value)).toLocaleString() }}
          </div>
        </template>
        <template #cell(tg)="data">
          <div class="text-nowrap">
            {{ parseFloat(Number(data.value)).toLocaleString() }}
          </div>
        </template>
        <template #cell(down_date)="data">
          <div class="text-nowrap">
            {{
              isValidDate(dateOffFormat(data.item.down_date, data.item.up_date))
            }}
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { getOccupancyByFilm, getOccupancyByTheatre } from '@/api/occupancy.js'
export default {
  name: '',
  data() {
    return {
      loading: false,
      queryVal: '',
      items: [],
    }
  },
  components: {},
  computed: {
    totalVal() {
      return function (val, hasItem) {
        if (hasItem) {
          return parseFloat(
            this.items[hasItem].reduce(
              (sum, item) => sum + Number(item[val]),
              0
            )
          ).toLocaleString()
        } else {
          return parseFloat(
            this.items.reduce((sum, item) => sum + Number(item[val]), 0)
          ).toLocaleString()
        }
      }
    },
    fields() {
      if (this.queryVal.type === 'theatre') {
        return [
          { key: 'circuit_name', label: 'Circuit Name', sortable: true },
          { key: 'theatre_name', label: 'Theatre Name', sortable: true },
          {
            key: 'num_of_film',
            label: 'No. of film',
            sortable: true,
            numType: true,
          },
          {
            key: 'num_of_show',
            label: 'No. of show',
            sortable: true,
            numType: true,
          },
          { key: 'seats', label: '期間座位', sortable: true },
          { key: 'ta', label: '期間人次', sortable: true, numType: true },
          { key: 'tg', label: '期間票房', sortable: true, numType: true },
          { key: 'occupancy', label: '入座率', sortable: true },
        ]
      } else {
        return [
          { key: 'film_name_cn', label: '電影名稱', sortable: true },
          { key: 'film_name_en', label: 'Film name', sortable: true },
          { key: 'up_date', label: '上映日期', sortable: true },
          { key: 'down_date', label: '落畫日期', sortable: true },
          { key: 'country', label: 'Country', sortable: true },
          {
            key: 'theatre_highest',
            label: '最高戲院數目',
            sortable: true,
            numType: true,
          },
          {
            key: 'screen_highest',
            label: '最高銀幕數目',
            sortable: true,
            numType: true,
          },
          { key: 'seats', label: '期間座位', sortable: true },
          { key: 'ta', label: '期間人次', sortable: true, numType: true },
          { key: 'tg', label: '期間票房', sortable: true, numType: true },
          { key: 'occupancy', label: '入座率', sortable: true },
        ]
      }
    }
  },
  created() {
    this.queryVal = this.$route.query
    if (this.queryVal.type === 'theatre') {
      this.getOccupancyByTheatre()
    } else {
      this.getOccupancyByFilm()
    }
  },
  mounted() {},
  methods: {
    getOccupancyByTheatre() {
      this.loading = true
      const data = {
        date_start: this.queryVal.dateStart,
        date_end: this.queryVal.dateEnd,
        search: '',
        area: this.queryVal.area,
        region: this.queryVal.region,
        film_id: this.queryVal.film_id,
        film_master_id: this.queryVal.from_circuit ? this.queryVal.film_master_id : this.queryVal.id,
        circuit: this.queryVal.from_circuit ? this.queryVal.id : this.queryVal.circuit,
        run_ver_property_id: this.queryVal.run_ver_property_id,
        page: 1,
        count: 10000
      }
      getOccupancyByTheatre(data)
        .then((res) => {
          const list = []
          res.data.map((el) => {
            list.push({
              circuit_name: el.theatre.circuit,
              theatre_name: el.theatre.full_name,
              num_of_film: el.num_film,
              num_of_show: el.num_show,
              ta: el.admissions_total,
              tg: el.gross,
              occupancy: el.occupancy,
              seats: el.adm_per_seats
            })
          })
          this.items = list
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getOccupancyByFilm() {
      this.loading = true
      const data = {
        date_start: this.queryVal.dateStart,
        date_end: this.queryVal.dateEnd,
        search: '',
        theatre: this.queryVal.from_circuit ? '' : this.queryVal.id,
        circuit: this.queryVal.from_circuit ? this.queryVal.id : this.queryVal.circuit,
        house: this.queryVal.houseId,
        area: this.queryVal.area,
        region: this.queryVal.region,
        film_master_id: this.queryVal.film_master_id,
        film_id: this.queryVal.film_id,
        run_ver_property_id: this.queryVal.run_ver_property_id,
        page: 1,
        count: 1000
      }
      getOccupancyByFilm(data)
        .then((res) => {
          const dataList = []
          res.data.forEach((el) => {
            dataList.push({
              film_name_cn: el.film_master.name_chinese,
              film_name_en: el.film_master.name_english,
              up_date: el.run_ver_info.date_release,
              down_date: el.run_ver_info.date_off,
              country: el.film_master.country,
              theatre_highest: el.num_theatre,
              screen_highest: el.num_screen,
              tg: el.gross,
              show: el.num_shows,
              occupancy: el.occupancy,
              ta: el.admissions_total,
              seats: el.adm_per_seats
            })
          })
          this.items = dataList
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
